import { Mapper } from "../../../../base/utils/mapper";
import { StepServiceModel } from "../../../../domain/models/consult/step-service.model";
import { StepServiceEntity } from "../entities/step-service.entity";

export class SetpsServiceImplementationRepositoryMapper extends Mapper<StepServiceEntity, StepServiceModel> {
    mapFrom(param: StepServiceEntity): StepServiceModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: StepServiceModel): StepServiceEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}